import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  Button,
} from "@material-ui/core";
import * as React from "react";
import { blue } from "@material-ui/core/colors";
import { EmployeeModel } from "../model/EmployeeModel";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: blue[100],
      color: blue[600],
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  onClose: any;
}
class AddCustomScheduleDialog extends React.Component<Props> {
  state = {
    selectedDate: new Date(),
    selectedTime: new Date(),
    selectedPerson: new EmployeeModel(),
  };

  handleClose = () => {
    this.props.onClose();
  };
  render() {
    const { open, dialogTitle } = this.props;
    return (
      <Dialog
        open={open}
        keepMounted={true}
        onClose={() => this.handleClose()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth={true}
      >
        <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <div style={{ width: "100%" }}></div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.handleClose();
            }}
          >
            {"CANCEL"}
          </Button>
          <Button
            disabled={
              this.state.selectedPerson && this.state.selectedPerson.position
                ? false
                : true
            }
            type="submit"
            onClick={() => {}}
          >
            {"SAVE"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(AddCustomScheduleDialog);
